import classnames from 'classnames';
import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import './TopBarDropdown.scss';
import { TopBarDropdownOption } from './TopBarDropdownOption';

const chevron = require('./chevron.svg');

interface TopBarDropdownProps {
  label: string;
  options: any[];
  leftBorder: boolean;
  onSelect: (thing) => void;
  className?: string;
}

class TopBarDropdownUnwrapped extends React.Component<TopBarDropdownProps, any> {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  toggle = () => this.setState({ open: !this.state.open });

  handleClickOutside = () => this.setState({ open: false });

  onClickOption = (option) => {
    this.setState({ open: false }, () => {
      this.props.onSelect(option);
    });
  };

  render() {
    let menu;

    if (this.state.open) {
      const options = this.props.options.map((option) => (
        <TopBarDropdownOption key={option.id} option={option} onClick={this.onClickOption} />
      ));

      menu = <ul className='top-bar-dropdown-menu'>{options}</ul>;
    }

    return (
      <div
        className={classnames(
          'top-bar-dropdown-container',
          {
            'top-bar-dropdown-left-b': this.props.leftBorder,
          },
          this.props.className
        )}
      >
        <div role='button' className='top-bar-dropdown' onClick={this.toggle}>
          <div className='top-bar-dropdown-value'>{this.props.label}</div>
          <img src={chevron} className='top-bar-dropdown-chevron' />
        </div>
        {menu}
      </div>
    );
  }
}

export const TopBarDropdown = onClickOutside(TopBarDropdownUnwrapped);
